import { Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Background from '../../../assets/images/background.png';
import colors from '../../../styles/settings/colors';

export const Root = styled.div`
  background: #f2f1f1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
`;

// export const PasswordRules = styled.div`
//   width: 70%;
//   .message-html {
//     background: white;
//     border-radius: 4px;
//     border: solid #c4c4c4 1px;
//     box-shadow: 0px 0px 2px rgb(66 66 66 / 9%);
//     margin: 0 28px;
//     padding: 8px 48px;
//   }
// `;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  min-width: 200px !important;
`;

export const Content = styled.div`
  align-items: center;
  box-sizing: border-box;
  column-gap: 16px;
  display: grid;
  grid-template-columns: ${(props) => (props.fullWidth ? '100% 0' : '30% 70%')};
  margin-top: 27vh;
  padding: 0 16px;
  width: 100%;

  .message-html {
    align-self: flex-start;
    background: white;
    border-radius: 4px;
    border: solid #c4c4c4 1px;
    box-shadow: 0px 0px 2px rgb(66 66 66 / 9%);
    margin: 0 28px;
    padding: 8px 48px;
    position: relative;
    top: 8px;
  }
`;

export const PasswordBox = styled.div`
  display: flex;
  flex-flow: row wrap;

  .container-password {
    margin: 0 64px;
    max-width: 500px;
  }

  .icon-show {
    margin-left: 425px;
    margin-right: 16px;
    margin-top: -48px;
    position: absolute;
    z-index: 3;
  }
`;

export const InputLabel = styled.label`
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 7px;
  padding-bottom: 8px;
  position: relative;
  bottom: 8px;
`;

export const InputText = styled(TextField)`
  text-transform: uppercase;
  width: 100%;

  .MuiInputBase-input {
    color: ${colors.tundora}!important;
  }

  .MuiInputBase-root {
    height: 48px;
    padding: 0 8px;
  }

  .MuiInputBase-root.Mui-disabled {
    background: #e0e0e0;
  }
`;

export const ActionFooter = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  padding: 16px 8px;
  width: 100%;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    color: '#fff',
    display: 'flex',
    padding: '0px 0px',
    width: '100%',
  },
  password: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    display: 'flex',
    padding: '0px 0px',
    width: '100%',
  },
  input: {
    color: '#fff',
    flex: 1,
    marginLeft: theme.spacing(1),
    paddingBottom: '10px',
    paddingTop: '10px',
  },
  iconButton: {
    color: '#fff',
  },
  button: {
    backgroundColor: '#fff',
    color: '#2148C0',
    marginTop: '12%',
    paddingBottom: '12px',
    paddingTop: '12px',
    textTransform: 'uppercase',
    width: '100%',
  },
  link: {
    color: '#2148C0',
    textDecoration: 'none',
    textTransform: 'uppercase',
  },
  icon: {
    color: '#fff',
    marginLeft: '10px',
  },
  grid: {
    alignItems: 'center',
    backgroundImage: `url(${Background})`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  logo: {
    height: '28vh',
    width: '25%',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '4%',
    width: '50%',
  },
  labelInput: {
    color: '#fff',
    marginTop: '16px',
    paddingBottom: '8px',
  },
  changeContainer: {
    columnGap: '16px',
    display: 'grid',
    gridTemplateColumns: '40% 40%',
    width: '100%',
  },
  messageHTML: {
    margin: '0 36px',
    padding: '0 36px',
  },
}));

export default useStyles;
